import { Controller } from "@hotwired/stimulus"
import { tsParticles } from "@tsparticles/engine"
import { loadSlim } from "@tsparticles/slim"

import { particlesOptions } from "../lib/particles_options.js"

export default class extends Controller {
  async connect() {
    const attached = new AbortController()
    this.attached = attached

    await loadSlim(tsParticles)
    if (attached.signal.aborted) return

    const container = await tsParticles.load({
      element: this.element,
      options: particlesOptions
    })

    if (attached.signal.aborted) {
      container?.destroy()
      return
    }
    this.container = container
  }

  disconnect() {
    this.attached?.abort()
    this.container?.destroy()
    this.container = null
  }
}
